import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {userTableReady,rowsPerPageState,searchTextState,paginationState} from '../redux/users'
import { headerDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/userTable.css'
import * as Helpers from '../../../common/helpers'


import  {ValidateEmail} from '../../../common/ValidationFunctions/CommonValidation'


function filterUnwantedData(usersData) {
    let array = []
    if (usersData && usersData.data && usersData.data.list) {
        array = usersData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.username = lineData.username ? lineData.username : "NA"
            newLineData.user_type = lineData.user_type ? lineData.user_type : "NA"


            newLineData.created_on = lineData.created ? Helpers.getDateTimeFormatForUTC(lineData.created) : ""

            newLineData.user_roles=""
            let user_roles=[]
            for (var j = lineData.user_roles.length - 1; j >= 0; j--) {
                user_roles.push(lineData.user_roles[j].role.name)
            }


            newLineData.system_profile_name=lineData.system_profile && lineData.system_profile.name ? lineData.system_profile.name : "NA"
            newLineData.employee_profile_name=lineData.employee_profile && lineData.employee_profile.name ? lineData.employee_profile.name +" ( "+lineData.employee_profile.code +" )" : "NA"
            
            newLineData.user_roles=user_roles.join(", ")
            newArray[i] = newLineData
        }
    }
    return newArray
}


class UsersTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            userData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(userTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.USERS_TABLE))

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getUsersData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getUsersData = () => {
        apiService.getUsersData()
            .then(usersData => {
                if (usersData && this.isComponentMounted) {
                    this.validateBuildNumber(usersData)
                    if (usersData.status === "SUCCESS") {
                        let array = filterUnwantedData(usersData), pageNo = 1
                        if (this.props.users && this.props.users.previousPaginationValue) {
                            pageNo = this.props.users.previousPaginationValue
                        }
                        this.setState({
                            userData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: usersData.reason ? usersData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(userTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(userTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.users && this.props.users.previousRowsPerPageValue) {
            value = this.props.users.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                   {/* <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.history.push("/dashboard/user/addEdit")
                            }}>
                            Add
                        </button> */}
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.userData.length>=(this.props.users.previousPaginationValue*this.props.users.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.users.previousPaginationValue*this.props.users.previousRowsPerPageValue)-this.props.users.previousRowsPerPageValue+1} to {this.props.users.previousPaginationValue*this.props.users.previousRowsPerPageValue} of {this.state.userData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.users.previousPaginationValue*this.props.users.previousRowsPerPageValue)-this.props.users.previousRowsPerPageValue+1} to {this.state.userData.length} of {this.state.userData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredCityList = () => {
       
        this.props.dispatch(userTableReady(false))
        this.resetSearchAndPagination()
        this.getUsersData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getUsersData()
        this.props.dispatch(userTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

    actionButtonsCreator = (cell, row) => {
        let resetPassword =""

        if(ValidateEmail(row.username.trim())){
        
           resetPassword=<button
                className="action-button"
                style={{marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.resetPassword(row)
                }}>
                <i class="fa fa-email"></i> Reset Password
            </button>
        }

        return (<div className="row">
            { <div className="col-md-12 col-sm-12 col-xs-12">{resetPassword}</div> }
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.users && this.props.users.previousPaginationValue
            && this.props.users.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    resetPassword = (row) => {        
        this.props.dispatch(userTableReady(false))
        if (row && row.id) {
            
            let browserInfo = this.state.details
            let ip = ""
            let data = {}, sourceDetails = {}
            data.registered_email = row.username.trim()
            sourceDetails.ip = ip ? ip : "NA"
            sourceDetails.details = browserInfo ? browserInfo : "NA"
            data.source_details = sourceDetails
            apiService.verifyEmailId(data)
                .then(responseData => {
                    if (responseData.status === "SUCCESS") {

        this.props.dispatch(userTableReady(true))
                       this.dialog.show({
                            title: "SUCCESS!!",
                            body: "Successfully Sent reset password link to user's email id.",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    } else {


        this.props.dispatch(userTableReady(true))
                         this.dialog.show({
                            title: "Error!!",
                            body: responseData.message,
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                })
                .catch(err => {

        this.props.dispatch(userTableReady(true))
                    console.error("Error message: ", err)
                    this.dialog.show({
                        title: "Error!!",
                        body: 'Something went wrong',
                        actions: [
                            Dialog.OKAction(() => {
                            })
                        ],
                    })
                })


        } else {

        this.props.dispatch(userTableReady(true))
            this.dialog.show({
                title: "City Identification number not found",
                body: 'City id is not available, So not able edit user',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.users && this.props.users.previousRowsPerPageValue) {
            sizeperPage = this.props.users.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="users-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.userData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                    <TableHeaderColumn
                        dataField="id"
                        isKey={true}
                        hidden={true}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="employee_profile_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Employee Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="username"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Username
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="user_type"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        User Type
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="user_roles"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        User Roles
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="created_on"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Created On
                    </TableHeaderColumn>



                    <TableHeaderColumn
                        dataFormat={this.actionButtonsCreator}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>



                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        users: state.users
    }
}

export default connect(mapStateToProps)(withRouter(UsersTable))


// WEBPACK FOOTER //
// ./src/modules/Users/Components/UsersTable.js